import PageSettings, { type PageSettingsProps } from "./PageSettings";

/**
 * Probability History: unified Page Settings modal (fleet sources, filters, Color By, date range).
 */
export default function ProbabilityHistoryPageSettings(props: PageSettingsProps) {
  return <PageSettings {...props} modalTitle={props.modalTitle ?? "Probability History settings"} />;
}
